import Vuex from 'vuex';
import { library } from "@common/library/library";

const logAction = (store) => {
    const _dispatch = store.dispatch; // Store original dispatch function
    store.dispatch = async function (type, payload) { // Override dispatch to prevent duplicate actions from running
        if (type.startsWith('actionStore/') && !type.startsWith('actionStore/runChainedActions') && !type.startsWith('actionStore/createHistoryNote')) {
            if (typeof PROJECT_WITH_ROUTER !== 'undefined') {
                // @todo move to the navigationStore
                let tmpQuery = {
                    ...router.currentRoute.value.query,
                    ...{
                        action: type.replace('actionStore/', ''),
                        actionParams: JSON.stringify(payload?.[0])
                    }
                };
                router.push({
                    path: router.currentRoute.value.path,
                    query: tmpQuery
                });
            }

            const actionsLog = store.state.actionStore.actionsLog;
            if (actionsLog.some((action) => action.hasOwnProperty(type) && library.isEqualObj(action[type], payload))) {
                // eslint-disable-next-line no-console
                console.warn(`${type} is already in process!`);
                return false; // stop action from running
            }
            let tmpPayload = library.cloneObj(payload);
            store.commit('actionStore/updateActionsLog', { type, payload: tmpPayload, act: 'add' });
            return _dispatch.call(store, type, payload); // Run original dispatch function for other actions
        }
        return _dispatch.call(store, type, payload); // Run original dispatch function for other actions
    };
    store.subscribeAction({
        after: (action, state) => {
            if (action.type.startsWith('actionStore/') && !action.type.startsWith('actionStore/runChainedActions') && !action.type.startsWith('actionStore/createHistoryNote')) {
                const { type, payload } = action;
                store.commit('actionStore/updateActionsLog', { ...action, act: 'remove' });
                if (typeof PROJECT_WITH_ROUTER !== 'undefined') {
                    // @todo move to the navigationStore
                    router.push({
                        path: router.currentRoute.value.path,
                    });
                }
            }
        },
        error: (action, state) => {
            if (action.type.startsWith('actionStore/') && !action.type.startsWith('actionStore/runChainedActions') && !action.type.startsWith('actionStore/createHistoryNote')) {
                const { type, payload } = action;
                store.commit('actionStore/updateActionsLog', { ...action, act: 'remove' });
                if (typeof PROJECT_WITH_ROUTER !== 'undefined') {
                    // @todo move to the navigationStore
                    router.push({
                        path: router.currentRoute.value.path
                    });
                }
            }
        }
    });
};

const store = new Vuex.Store({
    state: {
        debug: true,
    },
    plugins: [logAction]
});

/*
* global properties for vuex module
* can be rewritten by setting up same properties directly in module
* */
const moduleGlobalMixins = {
    state: {
        controls: {},
        actionsLog: [],
    },
    mutations: {
        // will be removed, please use set
        mutate: /* istanbul ignore next */function (state, payload) {
            let [property, value, cId] = Object.values(payload);
            let tmp = library.cloneObj(state[property]);
            if (typeof tmp === "undefined") tmp = {};
            if (typeof cId !== "undefined" && cId) {
                if (typeof (tmp[cId]) === "undefined") {
                    tmp[cId] = {};
                }
                tmp[cId] = value;
            } else {
                tmp = value;
            }
            if (!library.isEqualObj(state[property], tmp)) {
                state[property] = {}; // do not remove this, it helps react values
                state[property] = tmp; // NOSONAR
            }
        },
        set: /* istanbul ignore next */async function (state, payload) {
            let [property, value, cId] = Object.values(payload);
            let tmp = library.cloneObj(state[property]);
            let getTmpValue = (componentStoreId) => {
                let output = library.cloneObj(store.state[config.cType][property]);
                if (typeof output === 'undefined') output = {};
                if (typeof (output[componentStoreId]) === "undefined") {
                    output[componentStoreId] = {};
                }
                return output;
            };
            if (typeof tmp === "undefined" || tmp === null) tmp = {};
            if (typeof cId !== "undefined" && cId) {
                if (typeof (tmp[cId]) === "undefined") {
                    tmp[cId] = {};
                }
                tmp[cId] = value;
            } else {
                tmp = value;
            }
            if (!library.isEqualObj(state[property], tmp)) {
                state[property] = tmp; // NOSONAR
                // Set real property in store if prop came from props.
                let realProp = property.indexOf('prop') === 0
                    && library.lowerFirstLetter(property.replace('prop', ''));
                if (realProp) {
                    state[realProp] = tmp;
                }
                if (typeof cId !== "undefined") {
                    let config = await componentStore.getConfig(cId);
                    let componentStoreId = false;
                    let layoutStoreId = false;
                    if (store.state[config.cType] && store.state[config.cType]['iComponentStoreId'] && store.state[config.cType]['iComponentStoreId'][cId]) {
                        componentStoreId = store.state[config.cType]['iComponentStoreId'][cId];
                    }
                    if (store.state[config.cType] && store.state[config.cType]['iLayoutStoreId'] && store.state[config.cType]['iLayoutStoreId'][cId]) {
                        layoutStoreId = store.state[config.cType]['iLayoutStoreId'][cId];
                    }
                    if (layoutStoreId) {
                        store.state[layoutStoreId][property] = value;
                    } else if (componentStoreId) {
                        config = await componentStore.getConfig(componentStoreId);
                        let tmpValue = getTmpValue(componentStoreId);
                        tmpValue[componentStoreId] = value;
                        store.state[config.cType][property] = tmpValue;
                    }
                }
            }
        },
        updateActionsLog: function (state, payload) {
            if (payload.act === 'add') {
                if (payload.payload?.[0]?.component) {
                    if (payload.payload[0].component.cId) payload.payload[0].cId = payload.payload[0].component.cId;
                    delete payload.payload[0].component;
                }
                state.actionsLog.push({ [payload.type]: payload.payload });
            }
            if (payload.act === 'remove') {
                const index = state.actionsLog.findIndex((action) => {
                    if (payload.payload?.[0]?.component) {
                        if (payload.payload[0].component.cId) payload.payload[0].cId = payload.payload[0].component.cId;
                        delete payload.payload[0].component;
                    }
                    return action.hasOwnProperty(payload.type) && library.isEqualObj(action[payload.type], payload.payload);
                });
                if (index !== -1) state.actionsLog.splice(index, 1);
            }
            return state.actionsLog;
        }
    },
    getters: {
        get: /* istanbul ignore next */function (state) {
            return function (payload) {
                let [property, cId] = Object.values(payload);
                let output;
                if (typeof cId !== "undefined") {
                    if (typeof state[property] === 'undefined') {
                        state[property] = {};
                    }
                    if (typeof state[property][cId] === 'undefined') {
                        state[property][cId] = false;
                    }
                } else if (typeof state[property] === 'undefined') {
                    state[property] = false;
                }
                if (typeof cId !== "undefined") {
                    output = state[property][cId];
                }
                else if (state['prop' + library.capitalizeFirstLetter(property)]) {
                    output = state['prop' + library.capitalizeFirstLetter(property)];
                }
                else output = state[property];
                return output;
            };
        },
    }
};

/*
* helper function for create vuex module:
* - auto add controls state to module
* - save each mutations/actions/getters to module as function. For example sDs action post can be called from other
* module as sDs.post('sds_function', param1, param2...)
* */
store.oldRegisterModule = store.registerModule;
store.registerModule = function (name, module) {
    let tmpVuexMixins = library.cloneObj(moduleGlobalMixins);
    if (name === 'sDs') delete tmpVuexMixins.getters.get;
    for (const prop in tmpVuexMixins) {
        if (prop === 'length') continue;
        if (!module[prop]) module[prop] = {};
        for (const subprop in tmpVuexMixins[prop]) {
            if (subprop === 'length') continue;
            if (!module[prop][subprop]) module[prop][subprop] = tmpVuexMixins[prop][subprop];
        }
    }
    if (module.state && !module.state.controls) {
        module.state.controls = {};
    }
    if (!module.mutations) {
        module.mutations = {};
    }
    if (!module.getters) {
        module.getters = {};
    }

    let actions = [];
    for (const i in module.actions) {
        if (i === 'length') continue;
        let tmpName = Array.isArray(name) ? name.join('/') : name;
        let dName = tmpName + "/" + i;
        actions.push(dName);
        module[i] = /* istanbul ignore next */ (function (ddName) {
            return function () {
                let args = { ...arguments };
                return store.dispatch(ddName, args, { root: true });
            };
        }(dName));
    }
    let mutations = [];
    for (const i in module.mutations) {
        if (i === 'length') continue;
        let tmpName = Array.isArray(name) ? name.join('/') : name;
        let mName = tmpName + "/" + i;
        mutations.push(mName);
        if (actions.indexOf(mName) !== -1) {
            throw Error("Component " + name + " has action and mutation with same name " + i);
        }
        // eslint-disable-next-line no-loop-func
        module[i] = /* istanbul ignore next */(function (mmName) {
            return function () {
                let args = { ...arguments };
                // eslint-disable-next-line no-underscore-dangle
                if (typeof store._mutations[mmName] !== 'undefined') {
                    return store.commit(mmName, args, { root: true });
                }
                return null;
            };
        }(mName));
    }
    // let getters = [];
    for (const i in module.getters) {
        if (i === 'length') continue;
        let tmpName = Array.isArray(name) ? name.join('/') : name;
        let gName = tmpName + "/" + i;
        // getters.push(gName);
        if (actions.indexOf(gName) !== -1) {
            throw Error("Component " + name + " has action and getter with same name " + i);
        }
        if (mutations.indexOf(gName) !== -1) {
            throw Error("Component " + name + " has mutation and getter with same name " + i);
        }
        module[i] = /* istanbul ignore next */(function (ggName) {
            return function () {
                let args = { ...arguments };
                if (typeof store.getters[ggName] === 'function') {
                    return store.getters[ggName](args);
                }
                return null;
            };
        }(gName));
    }
    let isRegistered = false;
    if (Array.isArray(name)) {
        let layoutId = name[0];
        let cId = name[1];
        if (typeof store.state[layoutId][cId] !== 'undefined') {
            isRegistered = true;
        }
    } else if (typeof store.state[name] !== 'undefined') {
        isRegistered = true;
    }
    if (!isRegistered) {
        store.oldRegisterModule(name, module);
        window[name] = module;
        if (!Array.isArray(name)) {
            store[name] = module;
        }
    }
    return module;
};
window.store = store;

export { store, moduleGlobalMixins };
